import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { LazyMap } from '../../components/Map/Lazy';
import {
  PATH_GIS_MAP_SETTINGS,
  PATH_GIS_DEFAULT,
  PATH_GIS_FEATURE_DETAILS_CALCULATION_ASSUMPTIONS,
  PATH_GIS_FEATURE_DETAILS_DISTANCES,
  PATH_GIS_FEATURE_DETAILS_FOLDER_BUSINESS_ENTITY,
  PATH_GIS_FEATURE_DETAILS_GEOCODING,
  PATH_GIS_FEATURE_DETAILS_NATURAL_DISASTERS,
  PATH_GIS_FEATURE_DETAILS_OFFICIAL_JOURNAL,
  PATH_GIS_FEATURE_DETAILS_THIRD_PARTY,
} from '../../app/constants/paths.constant';
import { PathStrategy } from '../../components/Map/enums/path-strategy.enum';
import { StateStrategy } from '../../components/Map/enums/state-strategy.enum';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';
import { useMediaQuery, useTheme } from '@mui/material';

const paths = {
  featureDetailsCalculationAssumptions:
    PATH_GIS_FEATURE_DETAILS_CALCULATION_ASSUMPTIONS,
  featureDetailsDistances: PATH_GIS_FEATURE_DETAILS_DISTANCES,
  featureDetailsFolderBusinessEntity:
    PATH_GIS_FEATURE_DETAILS_FOLDER_BUSINESS_ENTITY,
  featureDetailsGeocoding: PATH_GIS_FEATURE_DETAILS_GEOCODING,
  featureDetailsNaturalDisasters: PATH_GIS_FEATURE_DETAILS_NATURAL_DISASTERS,
  featureDetailsOfficialJournal: PATH_GIS_FEATURE_DETAILS_OFFICIAL_JOURNAL,
  featureDetailsThirdParty: PATH_GIS_FEATURE_DETAILS_THIRD_PARTY,
  main: PATH_GIS_DEFAULT,
  mapSettings: PATH_GIS_MAP_SETTINGS,
} as const;

export const GisPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Gis);
  }, [setPage]);

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  const title = matches ? "Système d'Informations Géographiques" : 'SIG';

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle(title)}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_GIS_DEFAULT,
            label: title,
            key: 'gis',
          },
        ]}
      />
      <PageTitle title={title} />
      <LazyMap
        id="gis-map"
        pathStrategy={PathStrategy.RouterConnected}
        paths={paths}
        stateStrategy={StateStrategy.RouterConnected}
        useCase={{
          id: 'Gis',
          allowElementsList: true,
          description: "Système d'Informations Géographiques",
        }}
      />
    </>
  );
};
